var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":"","to":"/upgrade","target":"_blank"},slot:"activator"},[_c('img',{attrs:{"src":"https://img.icons8.com/color/48/000000/fairytale.png","height":"30px"}})]),_vm._v(" "),_c('span',[_vm._v("Fazer upgrade")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3848ece2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/PBtnUpgrade.vue
// module id = 867
// module chunks = 1